import axios from 'axios'
import {api} from '@/constants'
import qs from 'qs'

async function sendAnalyticsEvent(eventName, data) {
    const analyticData = [{
        event: 'nodeMainCTEvents',
        properties: {
            identity: sessionStorage.getItem('session_id'),
            evtName: eventName,
            evtData: {
                "platform": sessionStorage.getItem('platform'),
                "country": sessionStorage.getItem('country'),
                ...data
            }
        }
    }]

    try {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const data = qs.stringify({
            data: Buffer.from(JSON.stringify([analyticData[0]])).toString('base64')
        })
        await axios.post(api.ANALYTICS_API + '/track', data, config).catch((err) => {
            console.log(err.message, err.stack)
        })
    } catch (err) {
        console.log(err.message, err.stack)
    }
}

export {sendAnalyticsEvent}
